<template>
  <div class="users-index">
    <div class="header">
      <h1 class="page-header ">manage users</h1>
      <router-link v-if="hasAccess(userAbilitiesValue, 'MANAGE_USERS_CREATE')" to="/users/new" exact class="button larger" id="new-user-button">new user</router-link>
    </div>
    <div class="divider"></div>
    <div v-if="alert" class="error-message text-center">{{ alert }}</div>
    <table v-else class="unstriped">
      <thead>
        <tr>
          <th>email</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="user in users" :key="user.id">
          <td class="user-email">{{user.email}}</td>
          <td class="text-right">
            <router-link v-if="!user.is_current_user && hasAccess(userAbilitiesValue, 'MANAGE_USERS_EDIT')" :to="`/users/${user.id}/edit`" exact class="link user-edit-link">edit</router-link>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import AxiosMixin from '../../mixins/AxiosMixin'
  import UserAbilitiesMixin from '../../mixins/UserAbilitiesMixin'
  import { mapActions, mapGetters } from 'vuex'
  
  export default {
    name: 'UsersIndex',

    mixins: [AxiosMixin, UserAbilitiesMixin],

    data() {
      return {
        alert: null,
        users: null,
      }
    },

    methods: {
      getUsers() {
        this.axiosMethod({ 
          url: 'api/v3/users', 
          onSuccess: this.onGetUsersSuccess,
          onError: this.setAlert
        })
      },
      
      onGetUsersSuccess(data) {
        const isValidData = Array.isArray(data)
        isValidData ? this.users = data : this.setAlert()
      },
      
      setAlert(error) {
        const message = error ? error : 'error loading, please refresh'
        this.alert = message
      },
    },

    created() {
      this.getUsers()
      this.$store.dispatch('LOAD_CURRENT_USER')
    },

    computed: {
      ...mapGetters([
        'userAbilitiesValue'
      ])
    }
  }
</script>
